/**
 * VSB Verkoop — Vue IIFE voor OpenCart (mount op #vsb-vue-site-header).
 * Site-eigen entry: pas features/header/SiteHeader.vue aan zonder Verhuur te wijzigen.
 */
import { createApp } from 'vue';
import SiteHeader from '../features/header/SiteHeader.vue';

const mountSelector = '#vsb-vue-site-header';

function bootSiteHeader() {
  const el = document.querySelector(mountSelector);
  if (!el || el.dataset.vsbVueAutostart === '0') {
    return;
  }
  createApp(SiteHeader).mount(el);
  document.documentElement.classList.add('vsb-header--vue-ready');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootSiteHeader);
} else {
  bootSiteHeader();
}
